import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

@Component({
	selector: 'app-dynamic-dropdown',
	templateUrl: './dynamic-dropdown.component.html',
	styleUrls: ['./dynamic-dropdown.component.scss'],
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicDropdownComponent {
	@Input() field: any;
	@Output() optionSelected = new EventEmitter<any[]>();

	constructor(public controlContainer: ControlContainer) {}

	onSelectionChange(event: MatSelectChange) {
		const selectedValue = event.value;
		this.optionSelected.emit(selectedValue);
	}
}
